import React, { useState } from "react";
import { useSelector } from "react-redux";
import useClickOutside from "../../../CustomHooks/useClickOutside";

const tabTitles = {
  expenses: "Expenses",
  loanExpenses: "Loan Expense",
  pendingExpenses: "Pending Expenses",
};

const MobileTabbedView = ({ headerTabs, handleTabClick }) => {
  const [showTabsMenu, setShowTabsMenu] = useState(false);
  const { dropdownRef } = useClickOutside(() => setShowTabsMenu(false));
  const currentData = useSelector((state) => state.data.data);
  const activeHeaderTab = useSelector(
    (state) => state.activeHeaderTab.activeHeaderTab
  );

  const getTabClass = (tabName) => {
    return `border-b px-1 py-1 ${
      activeHeaderTab === tabName ? "bg-lb4 text-white" : ""
    }`;
  };

  const handleClickTab = (tabName, data) => {
    handleTabClick(tabName, data);
    setShowTabsMenu(false);
  };
  return (
    <div className="block relative" ref={dropdownRef}>
      <button
        className="border-b border-dark-blue px-1 pr-3"
        onClick={() => setShowTabsMenu((prev) => !prev)}
      >
        {tabTitles[activeHeaderTab]}{" "}
        <span className="text-xs">({currentData?.length})</span>
        <span
          className={`DropdownBlueArrow ${
            showTabsMenu ? "rotate-90" : "rotate-90n"
          }`}
        >{`<`}</span>
      </button>
      {showTabsMenu && (
        <ul className="font-figtree absolute shadow-sh-2 z-9999 bg-white w-40">
          {headerTabs.map(({ name, key, data }) => (
            <h4
              key={key}
              onClick={() => handleClickTab(key, data)}
              className={getTabClass(key)}
            >
              {name}
              <span className="text-sm">
                {" "}
                ({activeHeaderTab === key ? currentData?.length : data?.length})
              </span>
            </h4>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MobileTabbedView;
